import { FC } from 'react'

import { Categories } from './components/Categories/Categories'
import { FormBlock } from './components/FormBlock/FormBlock'
import { ListBlock } from './components/ListBlock/ListBlock'
import { MainBlock } from './components/MainBlock/MainBlock'
import { ProductsBlock } from './components/ProductsBlock/ProductsBlock'

type TProps = {}

const HomePageContent: FC<TProps> = () => {
  return (
    <div className="flex flex-1 flex-col">
      <MainBlock />
      <Categories />
      <ProductsBlock />
      <ListBlock />
      {/* <FormBlock /> */}
    </div>
  )
}

export { HomePageContent }
